import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./Nom035FinalScore.css";

function Nom035FinalScore({ finalScoreLabel }) {
  const badgeType = (label) => {
    switch (label) {
      case "Depreciable":
        return "none";

      case "Bajo":
        return "low";

      case "Medio":
        return "middle";

      case "Alto":
        return "high";

      case "Muy Alto":
        return "very-high";

      default:
        break;
    }
  };

  return (
    <Col className="nom035-final-score">
      <Row className="justify-content-center align-items-center">
        <Col lg={7}>
          <h3>Grado Final</h3>
        </Col>
        <Col lg={3}>
          <h5 className={badgeType(finalScoreLabel)}>{finalScoreLabel}</h5>
        </Col>
      </Row>
    </Col>
  );
}

export default Nom035FinalScore;
